<template>
    <div class="mainpage">
        <div class="d-flex mb-2">
            <div class="gap">
                <span class="p-input-icon-left">
                    <i class="pi pi-search" />
                    <InputText v-model="searchValue" placeholder="Search"/>
                </span>
            </div>
            <Dropdown class="gap" v-model="role" :options="roles" optionLabel="label" placeholder="Filter by role" optionValue="value" />
        </div>
        <div class="custom-table">
            <DataTable class="p-datatable" :value="userList" tableStyle="min-width: 50rem">
                <Column field="username" header="Name"></Column>
                <Column field="email" header="Mail ID"></Column>
                <Column field="role" header="Role"></Column>
                <Column field="created_time" header="Created On"></Column>
            </DataTable>
            <Paginator :rows="10" :totalRecords="120" :rowsPerPageOptions="[10, 20, 30]"></Paginator>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'

export default {
    name: 'User Management',
    components: {
    },
    data () {
        return {
            searchValue: '',
            role: '',
            roles: [ { label: 'Admin', value: 'admin' } ],
            userList: [ { username: 'akil', email: 'aki@tanla.com', role: 'Admin', created_time: 'today' },
                { username: 'neeraj', email: 'aki@tanla.com', role: 'Admin', created_time: 'today' },
                { username: 'sai', email: 'aki@tanla.com', role: 'Admin', created_time: 'today' },
                { username: 'naveen', email: 'aki@tanla.com', role: 'Admin', created_time: 'today' },
                { username: 'vinay', email: 'aki@tanla.com', role: 'Admin', created_time: 'today' }
            ]
        }
    },
    methods: {
        async logout () {
            await this.$store.dispatch('unsetUser')
            this.$router.push('/signin')
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapGetters({ currentUser: 'currentUser' })
    },
    mounted () {
    }
}
</script>

<style>
</style>
